<script>
export default {
  name: "BarHeading"
};
</script>

<template>
  <div class="flex items-center">
    <h4
      class="flex-shrink-0 pr-4 uppercase tracking-tight text-lg  text-black font-bold"
    >
      <slot></slot>
    </h4>
    <div class="flex-1 border-t-2 border-vectric" />
  </div>
</template>

<style scoped></style>
